import client from '@/clients/customer/api-client';

export interface AdBannerImage {
  id: number;
  uploadable_type: string;
  uploadable_id: number;
  disk: string;
  original_name: string;
  mime_type: string;
  path: string;
  thumb_path: string;
  url: string;
  thumb_url: string;
  relation_name: string;
  created_at: string;
  updated_at: string;
  order_index: number;
}

export interface AdBanner {
  id: number;
  shop: string;
  link: string;
  media: {
    desktop_image?: AdBannerImage[];
    mobile_image?: AdBannerImage[];
  };
  desktop_image: AdBannerImage | null;
  mobile_image: AdBannerImage | null;
}

export interface AdBannerResponse {
  data: AdBanner[];
}

export interface AdBannerParams {
  location: string;
  tag_ids: number[];
}

export async function fetchAdBanners(
  params: AdBannerParams
): Promise<AdBannerResponse> {
  const queryParams = new URLSearchParams();
  queryParams.set('location', params.location);

  // Add tag_ids as array parameters
  params.tag_ids.forEach((id) => {
    queryParams.append('tag_ids[]', id.toString());
  });

  const response = await client.get<AdBannerResponse>(
    `/ad-banner?${queryParams.toString()}`
  );

  return response.data;
}
